<template>
  <div class="attention-effect">
    <div class="el-input-grid">
      <character-select
        :selected="state.sourceCharacterKey"
        :characters="getSourceCharacters(emitter.caseConf)"
        :disabled="readonly"
        :errors="sourceCharacterErrors"
        placeholder="Select character"
        @input="selectCharacter"
      />
    </div>

    <div class="el-input-grid">
      <div class="group-wrapper">
        <div class="el-input-group el-input-group--prepend">
          <div class="el-input-group__prepend">Attention toward</div>
          <character-select
            :selected="state.targetCharacterKey"
            :characters="targetCharacters"
            :disabled="readonly"
            :errors="targetCharacterErrors"
            placeholder="Select target"
            @input="selectTarget"
          />
        </div>
      </div>
    </div>

    <div class="el-input-grid">
      <el-select
        v-close-on-zoom
        :value="state.attentionType"
        placeholder="Attention"
        :disabled="readonly"
        class="attention-type-select"
        @input="selectAttentionType"
      >
        <el-option
          v-for="type in attentionTypes"
          :key="type.value"
          :label="type.label"
          :value="type.value"
        />
      </el-select>
      <help-tooltip v-if="attentionTypeErrors.length" type="error">
        <div v-for="error in attentionTypeErrors" :key="error.message">{{ error.message }}</div>
      </help-tooltip>
    </div>
  </div>
</template>

<script>
import { getSourceCharacters, getTargetCharacters } from '~lib/common/utils/characters';
import { isNpc } from '~lib/common/utils/npc';
import { attentionTypes } from '~lib/common/utils/attentionTypes';
import nodeMixins from './mixins/NodeMixins';
import CharacterSelect from './CharacterSelect.vue';
import HelpTooltip from '../../common/components/HelpTooltip';

export default {
  name: 'attention-effect',
  components: {
    CharacterSelect,
    HelpTooltip,
  },
  mixins: [nodeMixins],
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control'],
  data() {
    return {
      attentionTypes,
      state: {
        sourceCharacterKey: null,
        targetCharacterKey: null,
        attentionType: null,
      },
    };
  },
  computed: {
    targetCharacters() {
      return getTargetCharacters(this.emitter.caseConf).
        filter(
          character =>
            character.key !== this.state.sourceCharacterKey &&
            character.key !== 'anyone'
        )
        .filter(character => {
          // Don't allow target to be NPC if source is NPC
          if (isNpc(this.state.sourceCharacterKey)) {
            return !isNpc(character.key)
          }
          return true;
        });
    },
    sourceCharacterErrors() {
      return this.getErrorsById('missingSourceCharacter');
    },
    targetCharacterErrors() {
      return this.getErrorsById('missingTargetCharacter');
    },
    attentionTypeErrors() {
      return this.getErrorsById('attentionType');
    },
  },
  created() {
    const data = this.getData(this.ikey);
    if (data) {
      this.state.sourceCharacterKey = data.sourceCharacterKey || null;
      this.state.targetCharacterKey = data.targetCharacterKey || null;
      this.state.attentionType = data.attentionType || null;
    }
    this.emitter.trigger('process', this.control);
  },
  methods: {
    selectCharacter(key) {
      this.state.sourceCharacterKey = key;
      if (this.state.targetCharacterKey) {
        this.state.targetCharacterKey = null;
      }
      this.update();
    },
    selectTarget(key) {
      this.state.targetCharacterKey = key;
      this.update();
    },
    selectAttentionType(value) {
      this.state.attentionType = value;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: 'ATTENTION',
        sourceCharacterKey: this.state.sourceCharacterKey,
        targetCharacterKey: this.state.targetCharacterKey,
        attentionType: this.state.attentionType,
      });
      this.emitter.trigger('process', this.control);
    },
    getSourceCharacters,
  },
};
</script>

<style scoped>
.attention-effect {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.el-input-grid {
  display: flex;
  align-items: flex-start;
  width: 100%;
}
.el-input-grid > .el-select,
.el-input-grid > .group-wrapper,
.el-input-grid > .character-select {
  flex: 1;
  min-width: 0;
}
.group-wrapper > .el-input-group {
  display: flex;
  width: 100%;
}
.el-input-group__prepend {
  flex: 1;
  align-items: center;
  display: flex;
}
.group-wrapper > .el-input-group > .el-input-grid {
  width: auto;
}
.help-tooltip {
  margin-left: 7px;
  margin-top: 7px;
}
</style>
